export default "__VITE_ASSET__130de392__"